import { render, staticRenderFns } from "./EditBulkUpcharge.vue?vue&type=template&id=3073d244&lang=pug"
import script from "./EditBulkUpcharge.vue?vue&type=script&lang=js"
export * from "./EditBulkUpcharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports